import { render, staticRenderFns } from "./OutStockMgmt.vue?vue&type=template&id=5cdb5f3c"
import script from "./OutStockMgmt.vue?vue&type=script&lang=js"
export * from "./OutStockMgmt.vue?vue&type=script&lang=js"
import style0 from "./OutStockMgmt.vue?vue&type=style&index=0&id=5cdb5f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports